const IconMicrowave = () => {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5878_125336)">
                <path
                    d="M27.5 7.33594H4.5C3.67157 7.33594 3 8.00751 3 8.83594V23.8359C3 24.6644 3.67157 25.3359 4.5 25.3359H27.5C28.3284 25.3359 29 24.6644 29 23.8359V8.83594C29 8.00751 28.3284 7.33594 27.5 7.33594Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M22 18.3359H26" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 21.3359H26" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M18 10.3359H7C6.44772 10.3359 6 10.7837 6 11.3359V21.3359C6 21.8882 6.44772 22.3359 7 22.3359H18C18.5523 22.3359 19 21.8882 19 21.3359V11.3359C19 10.7837 18.5523 10.3359 18 10.3359Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="24" cy="13.3359" r="2" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_5878_125336">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.335449)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconMicrowave;
